export const mmiDataTypes = {
  nearestBusStop: 'nearestBusStop',
  fromTo: 'fromTo',
  direction: 'direction',
};
